import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[engScrollIntoView]',
})
export class ScrollIntoViewDirective implements OnChanges {
  @Input()
  public engScrollIntoView: boolean = false;

  constructor(private el: ElementRef) {}

  ngOnChanges() {
    if (this.engScrollIntoView) {
      this.el.nativeElement.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: 'smooth',
      });
    }
  }
}
